import { render, staticRenderFns } from "./SReportFilters.vue?vue&type=template&id=6e36321b"
import script from "./SReportFilters.vue?vue&type=script&lang=js"
export * from "./SReportFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports